<template>
	<div>
		<div class="border p-5 mb-5">
			<h6>Akademik Yıl</h6>
			<academic-years-selectbox v-model="academicYear"/>
			<span>{{ academicYear }}</span>
		</div>
		<div class="border p-5">
			<b-row>
				<b-col md="12" class="mb-4">
					<h6>Null</h6>
					<module-selectbox v-model="value1" :academic_year="academicYear"/>
					<span>{{ value1 }}</span>
				</b-col>
				<b-col md="12" class="mb-4">
					<h6>Single Selected</h6>
					<module-selectbox v-model="value2" :academic_year="academicYear"/>
					<span>{{ value2 }}</span>
				</b-col>
				<b-col md="12" class="mb-4">
					<h6>Validate Error</h6>
					<module-selectbox v-model="value3" :academic_year="academicYear"/>
					<span>{{ value3 }}</span>
				</b-col>
				<b-col cols="12">
					<b-button variant="primary" @click="change()">
						{{ $t('change').toUpper() }}
					</b-button>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
	import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";
	import ModuleSelectbox from "@/components/interactive-fields/ModuleSelectbox";

	export default {
		components: {
			AcademicYearsSelectbox,
			ModuleSelectbox,
		},
		data() {
			return {
				academicYear: '2017-2018',

				value1: null,
				value2: 1,
				value3: 1,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.academicYear = '2017-2018'

				this.value2 = 2
				this.value3 = 2
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

